import React from "react";
import PageNotFoundImage from "../assets/Error/pagenotfound.avif";
import { Link } from "react-router-dom";
import Header from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
const PageNotFound = () => {
  return (
    <>
      <Header />
      <div>
        <div className="container">
          <div className="row marginbtm-240">
            <div className="col-md-12">
              <div className="four-o-four mt-3">
                <div className="d-flex justify-content-center">
                  <img
                    src={PageNotFoundImage}
                    className="paymentFail img-fluid h-50"
                    alt="payment failed"
                    height="550px"
                    width="550px"
                    loading="lazy"></img>
                </div>
                <div
                  className="center-block"
                  style={{
                    display: "grid",
                    justifyContent: "center",
                    textAlign: "center",
                  }}>
                  <p className="text-center pb-0 mb-0 fs-5">
                    The page you are looking for is not found.
                  </p>
                  <h3 className="fs-1 text-center">Something's Missing.</h3>
                  <div className="d-flex justify-content-center">
                    {/* <Link to="/" className="butn"> */}

                    {/* btn name chnage by laxmi  -----------------------------*/}
                    <Link
                      to="/"
                      className="thm-btn itm-btns mb-4 w-auto fw-bold fs-5">
                      Go to homepage
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default PageNotFound;
